import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import {
  ICreateRDDBResponse,
  IRDDBDetailResponse,
  ISubmittedRDDBsResponse,
  IValidRDDBimporter,
  IRDDBClaimantsubmitResponse,
} from '../models/api';
import * as dayjs from 'dayjs';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class RDDBService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  get baseCadUrlBP(): string {
    return `${this.endPointBP}/cad/duty-drawback/claimant`;
  }

  getListSubmittedRDDBs(
    minDate: Date,
    maxDate: Date,
    currentPage: number,
    pageSize: number,
    sortField: string,
    searchString: string = ''
  ): Observable<ISubmittedRDDBsResponse> {
    const endPoint = `${this.baseCadUrlBP}/summary-drawback-activities`;
    const params = new HttpParams()
      .set('startDate', dayjs(minDate).format('YYYY-MM-DD'))
      .set('endDate', dayjs(maxDate).format('YYYY-MM-DD'))
      .set('currentPage', currentPage.toString())
      .set('pageSize', pageSize.toString())
      .set('sdaSort', sortField)
      .set('searchString', searchString);
    return this.httpAuthGet<ISubmittedRDDBsResponse>(endPoint, params);
  }

  submitRDDB(): Observable<ICreateRDDBResponse> {
    const endPoint = `${this.baseCadUrlBP}/draft`;
    return this.httpAuthPost<ICreateRDDBResponse>(endPoint, {});
  }

  submitRDDBnoimp(programId: string): Observable<ICreateRDDBResponse> {
    const endPoint = `${this.baseCadUrlBP}/bn15/draft`;
    return this.httpAuthPost<ICreateRDDBResponse>(endPoint, {
      programId: programId,
    });
  }

  validateRDDBimporter(programId: string): Observable<IValidRDDBimporter> {
    const endPoint = `${this.baseCadUrlBP}/validate-importer`;
    return this.httpAuthPost<IValidRDDBimporter>(endPoint, {
      programId: programId,
    });
  }

  getRDDBDetails(caseId: string): Observable<IRDDBDetailResponse> {
    const endPoint = `${this.baseCadUrlBP}/${caseId}`;
    return this.httpAuthGet<IRDDBDetailResponse>(endPoint);
  }
  submitImporterClaimant(
    draftUid: string
  ): Observable<IRDDBClaimantsubmitResponse> {
    const endPoint = `${this.baseCadUrlBP}/draft/${draftUid}`;
    return this.httpAuthGet<IRDDBClaimantsubmitResponse>(endPoint);
  }

  submitExporterClaimant(
    draftUid: string,
    importerBN15: string
  ): Observable<IRDDBClaimantsubmitResponse> {
    const endPoint = `${this.baseCadUrlBP}/draft/${draftUid}/importerBN15/${importerBN15}`;
    return this.httpAuthGet<IRDDBClaimantsubmitResponse>(endPoint);
  }
}
